import React from 'react';
import { Outlet } from 'react-router-dom';
import { Navbar, Footer } from './common';

export default function Layout() {
  return (
    <div className="min-h-screen bg-[var(--mt-bg)]">
      <Navbar />
      <main>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
